import { render, staticRenderFns } from "./integration-crm-search-conversations.vue?vue&type=template&id=37633646&scoped=true&"
import script from "./integration-crm-search-conversations.vue?vue&type=script&lang=js&"
export * from "./integration-crm-search-conversations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37633646",
  null
  
)

export default component.exports